import React from 'react';
import { translate } from '@portal/services/i18n';
import { maskCpfOrCnpjHide } from '@portal/services/masks';
import { DateTime } from 'luxon';
import useReduxState from '@portal/hooks/useReduxState';
interface IProps {
  title?: string;
  transferType?: string;
  date?: string;
  name?: string;
  bank?: string;
  pixKey?: string;
  pixId?: string;
  transactionId?: string;
  taxIdentifier?: string;
  amount?: string;
  dueDate?: string;
  fine?: string;
  discount?: string;
  final?: string;
  original?: string;
  fees?: string;
  description?: string;
}

const TransferReceipt = ({
  transferType,
  date,
  name,
  bank,
  pixKey,
  pixId,
  transactionId,
  taxIdentifier,
  title,
  amount,
  dueDate,
  fine,
  discount,
  final,
  original,
  fees,
  description,
}: IProps) => {
  const {
    theme: { currentTheme },
  } = useReduxState();

  const renderDetails = () => {
    const details = [
      {
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.TO'),
        value: name,
        visible: name,
      },
      {
        label: translate(
          'PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.TAX_IDENTIFIER'
        ),
        value: maskCpfOrCnpjHide(taxIdentifier ?? ''),
        visible: taxIdentifier,
      },
      {
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.BANK'),
        value: bank,
        visible: bank,
      },
      {
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.PIX_KEY'),
        value: pixKey,
        visible: pixKey,
      },
      {
        visible: pixId,
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.PIX_ID'),
        value: pixId,
      },
      {
        visible: transactionId,
        label: translate(
          'PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.TRANSACTION_ID'
        ),
        value: transactionId,
      },
      {
        visible: dueDate,
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.DUE_DATE'),
        value: DateTime.fromISO(dueDate ?? '').toLocaleString(),
      },
      {
        visible: fees,
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.FINE'),
        value: fees,
      },
      {
        visible: original,
        label: translate(
          'PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.ORIGINAL_AMOUNT'
        ),
        value: original,
      },
      {
        visible: fine,
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.INTEREST'),
        value: fine,
      },
      {
        visible: discount,
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.DISCOUNT'),
        value: discount,
      },
      {
        visible: final,
        label: translate(
          'PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.FINAL_AMOUNT'
        ),
        value: final,
      },
      {
        visible: description,
        label: translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.DESCRIPTION'),
        value: description,
      },
    ];

    return details
      .filter((item) => item.visible)
      .map((item) => (
        <div key={item.label} className="transfer-receipt__details__row">
          <span className="transfer-receipt__data__label">{item.label}</span>
          <span className="transfer-receipt__data__value">{item.value}</span>
        </div>
      ));
  };

  return (
    <div
      className="transfer-receipt"
      style={{ border: `1px dashed ${currentTheme.borderColor}` }}
    >
      <div className="transfer-receipt__header">
        {title ? <p className="transfer-receipt__title">{title}</p> : null}
        {transferType ? (
          <>
            <p className="transfer-receipt__data__label">
              {translate(
                'PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.TRANSACTION_TYPE'
              )}
            </p>
            <p>{transferType}</p>
          </>
        ) : null}
        <div>
          <p className="transfer-receipt__title">
            {translate('PAGES.HOME.TRANSFER_CONFIRMATION.LABELS.AMOUNT')}
          </p>
          <p className="transfer-receipt__title">{amount}</p>
          <p>
            {(date ? DateTime.fromISO(date) : DateTime.now()).toFormat(
              translate('APPLICATION.DEFAULT_DATE_FORMAT.LUXON')
            )}
          </p>
        </div>
        {renderDetails()}
      </div>
    </div>
  );
};

export default TransferReceipt;
